import { render, staticRenderFns } from "./CargoSerieFormComponent.vue?vue&type=template&id=35245035&"
import script from "./CargoSerieFormComponent.vue?vue&type=script&lang=js&"
export * from "./CargoSerieFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports